import { render, staticRenderFns } from "./ChecklistQuestion002.vue?vue&type=template&id=3c8c1253"
import script from "./ChecklistQuestion002.vue?vue&type=script&lang=js"
export * from "./ChecklistQuestion002.vue?vue&type=script&lang=js"
import style0 from "./ChecklistQuestion002.vue?vue&type=style&index=0&id=3c8c1253&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports